package com.wintermar.inspection.feature.data.remote.mapper.template

import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.graphql.InspectionTemplateOptionsQuery
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import migrations.TemplateOptionTable

fun InspectionTemplateOptionsQuery.Data.toTemplateOptionModel(): List<TemplateOptionModel> {
    return inspectionTemplateOptions.map { option ->
        TemplateOptionModel(
            id = option.id.toString(),
            order = option.order,
            label = option.label,
            answerType = option.answerType
        )
    }
}

fun List<TemplateOptionTable>.toListTemplateOptionModel(): List<TemplateOptionModel> {
    return this.map {
        TemplateOptionModel(
            id = it.id,
            order = it.orderPosition.toInt(),
            label = it.label,
            answerType = InspectionAnswerType.safeValueOf(
                it.answerType
            )
        )
    }
}
